import React from 'react';

const WaitingOthersScreen = ({ statistic }) => {
  return (
    <div className="screen active">
      <div className="card">
        <h2>Waiting for Other Players</h2>
        <p>Waiting for other players to choose their cricketers for {statistic}...</p>
      </div>
    </div>
  );
};

export default WaitingOthersScreen;